module.exports = __webpack_public_path__ + "img/bg.0a37b5c4.jpg";